export default __webpack_public_path__ + "static/media/Zankyou Sanka.9df43a0c.mp3";